import { createAsyncThunk } from '@reduxjs/toolkit'
import ProcessedMedia from './processed-media-model'
import {
  delete_processedMedia,
  load_processedMedias,
  store_processedMedia,
} from './processedMedia-service'

export const LoadProcessedMediasAsync = createAsyncThunk<any, any>(
  'composer/load/processedMedia',
  async (params: { uid: string }) => {
    return await load_processedMedias(params)
  },
)

export const CreateProcessedMediaAsync = createAsyncThunk<any, any>(
  'composer/create/processedMedia',
  async (params: ProcessedMedia) => {
    return await store_processedMedia(params)
  },
)

export const DeleteProcessedMediaAsync = createAsyncThunk<any, any>(
  'composer/delete/processedMedia',
  async (params) => {
    return await delete_processedMedia(params)
  },
)
